import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.379 5.242a.7.7 0 0 1 .637.412l2.987 6.61q.024.047.043.096l.636 1.408a.7.7 0 0 1-1.276.576l-.472-1.045H4.81l-.473 1.046a.7.7 0 1 1-1.276-.578l.629-1.386a.7.7 0 0 1 .062-.137L6.74 5.653a.7.7 0 0 1 .638-.411m-1.933 6.657H9.3L7.377 7.64zm9.741-6.581a.7.7 0 0 1 .382.624v7.416h.732a.7.7 0 1 1 0 1.4h-3.037a.7.7 0 0 1-.001-1.4h.906V7.312l-.781.566a.7.7 0 0 1-.821-1.134l1.892-1.37a.7.7 0 0 1 .728-.056",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=AlphaNumericIcon20.js.map